export function OverviewPage() {
  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
      <header className="mb-12">
        <h1 className="text-4xl font-bold tracking-tight bg-linear-to-r from-white to-white/40 bg-clip-text text-transparent">
          System Overview
        </h1>
        <p className="text-white/40 mt-1 font-medium italic">Welcome back to the Ordyn Control Center</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {[
          { label: "Active Clients", value: "...", color: "from-purple-500 to-indigo-500" },
          { label: "Total Requests", value: "...", color: "from-blue-500 to-cyan-500" },
          { label: "System Health", value: "Optimal", color: "from-emerald-500 to-teal-500" },
        ].map((stat, i) => (
          <div key={i} className="glass-dark p-8 rounded-4xl border border-white/10 hover:border-white/20 transition-all hover:-translate-y-1 group">
            <p className="text-white/30 text-xs font-black uppercase tracking-widest mb-2">{stat.label}</p>
            <p className={`text-4xl font-black bg-linear-to-r ${stat.color} bg-clip-text text-transparent group-hover:scale-105 transition-transform origin-left`}>
              {stat.value}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-12 glass-dark p-12 rounded-[3rem] border border-white/10 relative overflow-hidden">
        <div className="relative z-10 max-w-2xl">
          <h2 className="text-2xl font-bold mb-4">Ready for Growth</h2>
          <p className="text-white/50 leading-relaxed mb-6">
            This panel is designed to be your central hub. You can manage multi-tenant clients, 
            monitor system health, and eventually configure advanced profile settings from this single interface.
          </p>
          <div className="flex gap-4">
            <div className="px-4 py-2 bg-white/5 rounded-full text-xs font-bold text-white/30 border border-white/5">v1.2.0 Stable</div>
            <div className="px-4 py-2 bg-purple-500/10 rounded-full text-xs font-bold text-purple-400 border border-purple-500/20">Production Ready</div>
          </div>
        </div>
        <div className="absolute right-[-10%] bottom-[-20%] w-[50%] h-full bg-purple-600/10 blur-[100px] rounded-full" />
      </div>
    </div>
  );
}
